import { render, staticRenderFns } from "./deviceDetailBox.vue?vue&type=template&id=4308128a"
import script from "./deviceDetailBox.vue?vue&type=script&lang=js"
export * from "./deviceDetailBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports